export const QUERY_PARAM_ITEM = 'item';
export const QUERY_PARAM_CUSTOMER = 'customer';
export const QUERY_PARAM_SALES_TYPE = 'salesType';
export const QUERY_PARAM_SALES_ID = 'salesId';
export const QUERY_PARAM_TAB_INDEX = 'tabIndex';
export const QUERY_PARAM_DATE_FILTER = 'dateFilter';

export const QUERY_PARAM_VALUE_SEPARATOR = ';';
